import React from 'react'
import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useMediaQueryContext } from '@fourthwall/components'
import { useOnceInView, useTagManager } from '@hooks'
import { routing } from '@utils/routing'

import type { MiniRecommendationSlideProps } from '../../MiniRecommendations.type'
import * as Carousel from '../../components/Carousel/Carousel'

const ID = 'ordersToSend' as const

const CarouselItem = styled(Carousel.Item)`
  background-color: rgba(225, 154, 0, 0.15);

  &:hover {
    background-color: rgba(225, 154, 0, 0.25);
  }
`

export const OrdersToSendSlide = ({
  data,
  'data-role': dataRole,
}: MiniRecommendationSlideProps) => {
  const { tablet } = useMediaQueryContext()
  const navigate = useNavigate()
  const tagManager = useTagManager()

  const unfulfilledOrdersCount = data.ordersToSend?.unfulfilledOrdersCount || 0
  const viewRef = useOnceInView(() => {
    tagManager.trigger('mini_recommendation_view', {
      type: ID,
    })
  })

  if (!unfulfilledOrdersCount) {
    return null
  }

  const redirectToOrdersToSend = () => {
    tagManager.trigger('mini_recommendation_click', {
      type: ID,
    })

    navigate(routing.contributions.fulfillment)
  }

  return (
    <CarouselItem
      ref={viewRef}
      data-role={dataRole}
      data-analytics={ID}
      onClick={redirectToOrdersToSend}
    >
      <Carousel.ContentLeft>
        <Carousel.ItemEmote>📦</Carousel.ItemEmote>
        {tablet && (
          <Carousel.ItemText>
            You have {unfulfilledOrdersCount} {unfulfilledOrdersCount === 1 ? 'order' : 'orders'}{' '}
            left to send
          </Carousel.ItemText>
        )}
        {!tablet && (
          <Carousel.ItemText>
            {unfulfilledOrdersCount} {unfulfilledOrdersCount === 1 ? 'order' : 'orders'} left to
            send
          </Carousel.ItemText>
        )}
      </Carousel.ContentLeft>
    </CarouselItem>
  )
}
